import { render, staticRenderFns } from "./equalize-feature-container.component.vue?vue&type=template&id=538ab750&scoped=true"
import script from "./equalize-feature-container.component.vue?vue&type=script&lang=ts"
export * from "./equalize-feature-container.component.vue?vue&type=script&lang=ts"
import style0 from "./equalize-feature-container.component.vue?vue&type=style&index=0&id=538ab750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ab750",
  null
  
)

export default component.exports